@if (answer$ | async; as answer) {
  <div class="flex w-full flex-col p-2 md:py-2">
    <div class="flex items-center justify-between pb-2 flex-row">
      <div class="flex w-fit gap-1">
        <span class="font-goldplay text-lg font-normal text-base-gray-light-900">{{
          'eclass.observacao-aluno' | translate
        }}</span>
      </div>
      <div class="flex items-center justify-center gap-2 p-2 sm:justify-normal">
        <button
          app-icon-button
          (click)="onChangeModeViewFeedback(modeViewFeedbackEnum.AddText)"
          type="button"
          app-tooltip
          [tooltip]="'eclass.adicionar-feedback' | translate"
          class="group border border-theme-500 hover:bg-theme-500"
        >
          <svg-icon
            class="flex h-4 w-4 text-theme-500 group-hover:text-theme-contrast"
            src="assets/icons/icon-pencil.svg"
          ></svg-icon>
        </button>
        <button
          app-icon-button
          (click)="onChangeModeViewFeedback(modeViewFeedbackEnum.File)"
          type="button"
          app-tooltip
          [tooltip]="'eclass.fazer-upload' | translate"
          class="group border border-theme-500 hover:bg-theme-500"
        >
          <svg-icon
            class="flex h-4 w-4 text-theme-500 group-hover:text-theme-contrast"
            src="assets/icons/icon-upload-fine.svg"
          ></svg-icon>
        </button>
      </div>
    </div>
    <div class="h-fit w-full overflow-y-auto rounded-lg border border-dashed border-theme-200 p-2 md:p-4 text-center">
      @switch (modeViewFeedback$ | async) {
        @case (modeViewFeedbackEnum.List) {
          <app-modal-review-feedback-list
            [data]="answer.feedback"
            (edit)="onEditFeedback($event)"
            (removed)="onRemoveFeedback($event)"
          ></app-modal-review-feedback-list>
        }
        @case (modeViewFeedbackEnum.AddText) {
          <app-modal-review-feedback-text
            [data]="feedbackSelected$ | async"
            (close)="onCloseFeedback($event)"
          ></app-modal-review-feedback-text>
        }
        @case (modeViewFeedbackEnum.File) {
          <app-modal-review-feedback-file
            (close)="onCloseModeViewFeedbackFile($event)"
          ></app-modal-review-feedback-file>
        }
      }
    </div>
  </div>
}
